// removed by extract-text-webpack-plugin
module.exports = {"container":"_2crmW","message":"_1MrZl","title":"_37s6P","content":"_2iyxB","button":"g7DNb"};


//////////////////
// WEBPACK FOOTER
// ./app/components/share-link-form/share-link-form.scss
// module id = 896
// module chunks = 3 4 5 6 7